import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminEquivalenciasPage } from "@/features/admin-equivalencias-unidad/components/AdminEquivalenciasPage";
import { equivalenciasAdminQueryOptions } from "@/features/admin-equivalencias-unidad/hooks/use-equivalencias-admin";

/** Ruta `/admin/equivalencias-unidad` · CRUD del catálogo de equivalencias de unidad SAT↔SAP. */
export const Route = createFileRoute("/_authed-tw/admin/equivalencias-unidad")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminEquivalenciasUnidad])
      ? queryClient.ensureQueryData(equivalenciasAdminQueryOptions({ page: 1, pageSize: 15 }))
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminEquivalenciasUnidad]}>
      <AdminEquivalenciasPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
